<template>
  <div class="tmsDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.platformOrders.label1 }}</div>

      <van-field
        v-model="content.order_customerinvoicecode"
        :label="$t.platformOrders.customerinvoicecode"
        disabled
      />

      <van-field
        v-model="content.order_piece"
        :label="$t.platformOrders.orderPiece"
        disabled
      />
      <van-field
        v-model="content.order_returnsign"
        :label="$t.platformOrders.orderReturnsign"
        disabled
      />
      <van-field
        v-model="content.trade_type"
        :label="$t.platformOrders.tradeType"
        disabled
      />
      <van-field
        v-model="content.weight"
        :label="$t.platformOrders.totalWeight"
        disabled
      />
      <van-field
        v-model="content.volume"
        :label="$t.platformOrders.totalValue"
        disabled
      />
      <van-field
        v-model="content.order_transactionurl"
        :label="$t.platformOrders.orderTransactionurl"
        disabled
      />
      <van-field
        v-model="content.paymenttype_code"
        :label="$t.platformOrders.paymenttypeCode"
        disabled
      />
      <van-field
        v-model="content.order_codamount"
        :label="$t.platformOrders.orderCodamount"
        disabled
      />
      <van-field
        v-model="content.order_codcurrency"
        :label="$t.platformOrders.orderCodcurrency"
        disabled
      />
      <van-field
        v-model="content.order_cargoamount"
        :label="$t.platformOrders.orderCargoamount"
        disabled
      />
      <van-field
        v-model="content.order_insurance"
        :label="$t.platformOrders.orderInsurance"
        disabled
      />
      <van-field
        v-model="content.cargo_type"
        :label="$t.platformOrders.cargoType"
        disabled
      />
      <van-field
        v-model="content.ExpectedDeliveryDate"
        :label="$t.platformOrders.expectedDeliveryDate"
        disabled
      />

      <div class="title">{{ $t.platformOrders.label2 }}</div>

      <van-field
        v-model="content.consignee_name"
        :label="$t.platformOrders.consigneeName"
        disabled
      />
      <van-field
        v-model="content.consignee_companyname"
        :label="$t.platformOrders.consigneeCompanyname"
        disabled
      />
      <van-field
        v-model="content.consignee_telephone"
        :label="$t.platformOrders.consigneeTelephone"
        disabled
      />
      <van-field
        v-model="content.consignee_address"
        :label="$t.platformOrders.consigneeAddress"
        disabled
      />
      <van-field
        v-model="content.consignee_country"
        :label="$t.platformOrders.consigneeCountry"
        disabled
      />
      <van-field
        v-model="content.consignee_state"
        :label="$t.platformOrders.consigneeState"
        disabled
      />
      <van-field
        v-model="content.consignee_city"
        :label="$t.platformOrders.consigneeCity"
        disabled
      />
      <van-field
        v-model="content.consignee_postcode"
        :label="$t.platformOrders.consigneePostcode"
        disabled
      />
      <van-field
        v-model="content.consignee_passportno"
        :label="$t.platformOrders.consigneePassportno"
        disabled
      />
      <van-field
        v-model="content.consignee_email"
        :label="$t.platformOrders.consigneeEmail"
        disabled
      />
      <van-field
        v-model="content.consignee_taxno"
        :label="$t.platformOrders.consigneeTaxno"
        disabled
      />

      <div class="title">{{ $t.platformOrders.label3 }}</div>

      <van-field
        v-model="content.shipper_name"
        :label="$t.platformOrders.shipperName"
        disabled
      />
      <van-field
        v-model="content.shipper_companyname"
        :label="$t.platformOrders.shipperCompanyname"
        disabled
      />
      <van-field
        v-model="content.shipper_telephone"
        :label="$t.platformOrders.shipperTelephone"
        disabled
      />
      <van-field
        v-model="content.shipper_address"
        :label="$t.platformOrders.shipperAddress"
        disabled
      />
      <van-field
        v-model="content.shipper_country"
        :label="$t.platformOrders.shipperCountry"
        disabled
      />
      <van-field
        v-model="content.shipper_state"
        :label="$t.platformOrders.shipperState"
        disabled
      />
      <van-field
        v-model="content.shipper_city"
        :label="$t.platformOrders.shipperCity"
        disabled
      />
      <van-field
        v-model="content.shipper_postcode"
        :label="$t.platformOrders.shipperPostcode"
        disabled
      />
      <van-field
        v-model="content.shipper_passportno"
        :label="$t.platformOrders.shipperPassportno"
        disabled
      />
      <van-field
        v-model="content.shipper_email"
        :label="$t.platformOrders.shipperEmail"
        disabled
      />
      <van-field
        v-model="content.shipper_taxnotype"
        :label="$t.platformOrders.shipperTaxnotype"
        disabled
      />
      <van-field
        v-model="content.shipper_taxno"
        :label="$t.platformOrders.shipperTaxno"
        disabled
      />
      <van-field
        v-model="content.shipper_taxnocountry"
        :label="$t.platformOrders.shipperTaxnocountry"
        disabled
      />

      <div class="title">{{ $t.platformOrders.label4 }}</div>
      <van-field
        v-model="content.import_code"
        :label="$t.platformOrders.importCode"
        disabled
      />
      <van-field
        v-model="content.import_name"
        :label="$t.platformOrders.importName"
        disabled
      />
      <van-field
        v-model="content.import_companyname"
        :label="$t.platformOrders.importCompanyname"
        disabled
      />
      <van-field
        v-model="content.import_address"
        :label="$t.platformOrders.importAddress"
        disabled
      />
      <van-field
        v-model="content.import_telephone"
        :label="$t.platformOrders.importTelephone"
        disabled
      />
      <van-field
        v-model="content.import_email"
        :label="$t.platformOrders.importEmail"
        disabled
      />
      <van-field
        v-model="content.import_postcode"
        :label="$t.platformOrders.importPostcode"
        disabled
      />
      <van-field
        v-model="content.import_country"
        :label="$t.platformOrders.importCountry"
        disabled
      />
      <van-field
        v-model="content.import_state"
        :label="$t.platformOrders.importState"
        disabled
      />
      <van-field
        v-model="content.import_city"
        :label="$t.platformOrders.importCity"
        disabled
      />

      <div class="title">{{ $t.platformOrders.label5 }}</div>

      <div
        class="list-container"
        v-for="(item, index) in content.OrderProductList"
        :key="index"
      >
        <div class="list-item">
          {{ $t.platformOrders.invoiceAmount }}：{{ item.invoice_amount }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceCurrency }}：{{ item.invoice_currency }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceTitle }}：{{ item.invoice_title }}
        </div>
        <div class="list-item">{{ $t.platformOrders.sku }}：{{ item.sku }}</div>
        <div class="list-item">
          {{ $t.platformOrders.skuCode }}：{{ item.sku_code }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.hsCode }}：{{ item.hs_code }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoicePcs }}：{{ item.invoice_pcs }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceWeight }}：{{ item.invoice_weight }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceVolume }}：{{ item.invoice_volume }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.volumeHeight }}：{{ item.volume_height }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.volumeLength }}：{{ item.volume_length }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.volumeWidth }}：{{ item.volume_width }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.volumeWeight }}：{{ item.volume_weight }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.transactionUrl }}：{{ item.transaction_url }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceunitCode }}：{{ item.invoiceunit_code }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceImgurl }}：
          <van-image
            width="30"
            height="30"
            fit="cover"
            style="vertical-align: middle"
            @click="imagePreview(imgUrlFilter(item.invoice_imgurl))"
            :src="imgUrlFilter(item.invoice_imgurl)"
            v-if="item.invoice_imgurl"
          />
          <span v-else>{{ $t.platformOrders.noImage }}</span>
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceBrand }}：{{ item.invoice_brand }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceRule }}：{{ item.invoice_rule }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceTaxno }}：{{ item.invoice_taxno }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.originCountry }}：{{ item.origin_country }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoiceMaterial }}：{{ item.invoice_material }}
        </div>
        <div class="list-item">
          {{ $t.platformOrders.invoicePurpose }}：{{ item.invoice_purpose }}
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "tmsDetail",
  data() {
    return {
      HOId: "",
      content: {},
    };
  },
  created() {
    const { HOId } = this.$route.query;
    this.HOId = HOId;
    this.getHualeiOrderByHOId();
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getHualeiOrderByHOId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          HOId: this.HOId,
        };
        this.$api.platformOrders
          .getHualeiOrderByHOId(param)
          .then((res) => {
            this.content = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tmsDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      font-size: 14px;
      margin-right: 12px;
      color: #323233;
      display: inline-block;
      vertical-align: middle;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .list-container {
    font-size: 12px;
    color: #333;
    padding: 10px;
    margin-top: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .list-item {
      margin-bottom: 10px;
      width: 50%;
      display: inline-block;
    }
    .list-item:nth-last-child(2) {
      margin-bottom: 0px;
    }
    .list-item:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
